import imgix from "imgix.js";

export default class Imgix {
    constructor() {
        if (imgix.instance) {
            return imgix.instance;
        }
        imgix.instance = this;

        this.registeredEvents = new Set();
        this.init();
    }

    init = () => {
        document.querySelectorAll("img.imgix-fluid").forEach((img) => {
            this.applyImgixSrcSet(img);
        });

        document.querySelectorAll(".imgix-bg").forEach((el) => {
            this.applyBackgroundImage(el);
        });

        this.registerEvents(["revealOffcanvas", "ajaxModalHasLoaded"]);
    };

    applyImgixSrcSet = (img) => {
        const imagePath = img.dataset.src;
        const ixParams = JSON.parse(
            img.getAttribute("ix-params") ||
                '{"fit":"crop", "crop":"faces,edges"}'
        );

        // Build the query string
        const paramsString = new URLSearchParams(ixParams).toString(); // focal point
        const finalUrl = `${imagePath}${
            imagePath.includes("?") ? "&" : "?"
        }${paramsString}`;

        // Define widths for the srcset
        const aspectRatio = img.height / img.width;
        const widths = [360, 420, 768, 900, 1024, 1280, 1440, 1600, 2000]; // srcset sizes to be generated
        const dimensions = (width) => {
            let value = `&w=${width}`;
            if (!img.classList.contains("img-fit")) {
                value += `&h=${Math.round(width * aspectRatio)}`;
            }
            return value + "&q=70";
        };

        // Create the srcset and fallback src
        img.srcset = widths
            .map((width) => `${finalUrl}${dimensions(width)} ${width}w`)
            .join(", ");
        img.src = `${finalUrl}&q=70`; // Fallback src / noscript src
        img.sizes = "(max-width: 800px) 100vw, 2000px";
        img.loading = img.dataset.load; // Lazy / Eager

        // Add loaded class on load
        img.onload = () => img.classList.add("has-loaded");
    };

    applyBackgroundImage = (el) => {
        const imagePath = el.dataset.src;
        const backgroundImageUrl = `${imagePath}&fit=clip&q=75`;

        // Apply as a background image
        el.style.backgroundImage = `url(${backgroundImageUrl})`;
    };

    registerEvents = (events) => {
        events.forEach((event) => {
            if (!this.registeredEvents.has(event)) {
                document.addEventListener(event, () => this.handleEvent());
                this.registeredEvents.add(event);
            }
        });
    };

    handleEvent = (scope = document) => {
        scope.querySelectorAll("img.imgix-fluid").forEach((img) => {
            this.applyImgixSrcSet(img);
        });

        scope.querySelectorAll(".imgix-bg").forEach((el) => {
            this.applyBackgroundImage(el);
        });
    };

    process = (el) => {
        if (el.classList.contains("imgix-fluid")) {
            this.applyImgixSrcSet(el);
        } else {
            this.handleEvent(el);
        }
    };
}
